module.exports = __webpack_public_path__ + "img/D1_HQ02.2519ec77.jpg";